import { render, staticRenderFns } from "./OvertimeAdminApproval.vue?vue&type=template&id=24036e78&scoped=true"
import script from "./OvertimeAdminApproval.vue?vue&type=script&lang=js"
export * from "./OvertimeAdminApproval.vue?vue&type=script&lang=js"
import style0 from "./OvertimeAdminApproval.vue?vue&type=style&index=0&id=24036e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24036e78",
  null
  
)

export default component.exports